import { TFunction } from "i18next";
import {
  ESenderRole,
  IContractDetailsResponseData,
  UserProfile,
} from "../../../../setup/api/services/contract/models";

export const getPartyRoleTitle = (
  role: ESenderRole,
  t: TFunction<"translation", undefined>
): string => {
  switch (role) {
    case ESenderRole.PROVIDER:
      return t("lbl_the_seller");
    case ESenderRole.CUSTOMER:
      return t("lbl_the_buyer");
    case ESenderRole.BROKER:
      return t("lbl_arbitrator_title");
    case ESenderRole.SERVICE_PROVIDER:
      return t("lbl_shipping_company");
    default:
      return role;
  }
};

export const getPartyKycTitle = (
  kycLevel: string,
  t: TFunction<"translation", undefined>
): string => (kycLevel === "VERIFIED" ? t("lbl_yes") : t("lbl_no"));

export const getPartyUserStatusTitle = (
  userStatus: string,
  t: TFunction<"translation", undefined>
): string =>
  userStatus === "ACTIVE"
    ? t("lbl_settlement_advisory_user_status_active")
    : t("lbl_settlement_advisory_user_status_inactive");

// Quick-transaction contracts have no `partiesProfiles`/`parties` — the only
// customer/provider data lives on `contract.customer`/`contract.provider`.
const getQuickTransactionPartyProfile = (
  contract: IContractDetailsResponseData | undefined | null,
  role: ESenderRole,
  userId: string
): Partial<UserProfile> | undefined => {
  const user =
    role === ESenderRole.CUSTOMER
      ? contract?.customer
      : role === ESenderRole.PROVIDER
      ? contract?.provider
      : undefined;

  if (!user || String(user.userIdentification) !== userId) return undefined;

  return {
    userIdentification: user.userIdentification,
    phoneNumber: user.phoneNumber,
    nationalIdVerified: user.nationalIdVerified,
    profile: user.profile,
  };
};

export const getPartyProfile = (
  contract: IContractDetailsResponseData | undefined | null,
  role: ESenderRole,
  userId: string
): Partial<UserProfile> | undefined =>
  contract?.partiesProfiles?.[role]?.find(
    (profile) => String(profile.userIdentification) === userId
  ) || getQuickTransactionPartyProfile(contract, role, userId);

export const getPartyFullName = (
  contract: IContractDetailsResponseData | undefined | null,
  role: ESenderRole,
  userId: string
): string | undefined =>
  getPartyProfile(contract, role, userId)?.profile?.fullName;
